import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface SystemConfigurationState {
  decimalValue: number;
  chartType: "bar" | "line";
  powerOutageReasonCode: string;
  nem12ViewerFilesLimit: number;
}

const initialState: SystemConfigurationState = {
  decimalValue: 2, // Default value
  chartType: "bar", // Default value
  powerOutageReasonCode: "", // Default value
  nem12ViewerFilesLimit: 10, // Default value
};

export const systemConfigurationSlice = createSlice({
  name: "systemConfiguration",
  initialState,
  reducers: {
    setDecimalValue: (state, action: PayloadAction<number>) => {
      state.decimalValue = action.payload;
    },
    setChartType: (state, action: PayloadAction<"bar" | "line">) => {
      state.chartType = action.payload;
    },
    setPowerOutageReasonCode: (state, action: PayloadAction<string>) => {
      state.powerOutageReasonCode = action.payload;
    },
    setNem12ViewerFilesLimit: (state, action: PayloadAction<number>) => {
      state.nem12ViewerFilesLimit = action.payload;
    },
  },
});

export const {
  setDecimalValue,
  setChartType,
  setPowerOutageReasonCode,
  setNem12ViewerFilesLimit,
} = systemConfigurationSlice.actions;

export default systemConfigurationSlice.reducer;
